import { Image20Regular, Link20Regular, MoreHorizontal20Regular } from '@/components/Icon'
import { IconButton } from '@mui/material'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function AiAskBarEmailReplyToolbarSecondary() {
  return (
    <>
      <Tooltip text="Insert link" placement="top">
        <IconButton type="button" className={styles.circleAction} aria-label="Insert link">
          <Link20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      <Tooltip text="Insert image" placement="top">
        <IconButton type="button" className={styles.circleAction} aria-label="Insert image">
          <Image20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      <Tooltip text="More options" placement="top">
        <IconButton type="button" className={styles.circleAction} aria-label="More options">
          <MoreHorizontal20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
    </>
  )
}
